// extracted by mini-css-extract-plugin
export default {"duplexBannerPremiumContainer":"Lt6nmfvdee9cEaN7PI5K","imageBannerPremiumContainer":"j3UHtj2fQUY8MkNsi5mA"};